import React, { useState, useEffect } from 'react';

function CountItem({ label, endpoint, duration }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (count < endpoint) {
        setCount(prevCount => prevCount + 1);
      } else {
        clearInterval(interval);
      }
    }, duration / endpoint);

    return () => clearInterval(interval);
  }, [count, endpoint, duration]);

  return (
    <div className="count-item">
      <h3>{count}<span>+</span></h3>
      <p>{label}</p>
    </div>
  );
}

function Count() {
  return (
    <section className="abt-count-section">
      <div className="container">
        <div className="abt-count-row">
          <div className="count-container">
            <CountItem label="Employees" endpoint={12} duration={6000} />
            <CountItem label="Years of Experience" endpoint={8} duration={6000} />
            <CountItem label="Clients Served" endpoint={60} duration={6000} />
            <CountItem label="Projects Completed" endpoint={60} duration={6000} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Count;
